// ============================================================================
// REPOSITORY: ConsentGateRepository — atualização de consentimento do cliente
// ARQUIVO: src/services/ConsentGateRepository.js
// ============================================================================

import { doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function updateClientConsentLegacy(clientId, patch) {
  await updateDoc(doc(db, ...FS.clientsRoot(clientId)), patch);
}

export async function updateClientConsent(clientId, patch, appId = DEFAULT_APP_ID) {
  await updateDoc(doc(db, ...FS.clients(appId), clientId), patch);
}

export async function setClientConsent(clientId, patch, appId = DEFAULT_APP_ID) {
  await setDoc(doc(db, ...FS.clients(appId), clientId), patch, { merge: true });
}

export function getConsentPatch() {
  return {
    'metadata.hasConsented': true,
    'metadata.consentedAt': serverTimestamp(),
  };
}
